export interface PaletteOption {
  id: string;
  label: string;
  swatches: [string, string, string];
}

// "Doré" is the house default (matches every other panel in this codebase -
// mailbox/professionsMenu/factionPanel) - listed first, others are optional
// accent variants a player can switch to. Applied globally via `:root`'s
// `data-palette` attribute (see main.scss) so it reaches every panel's
// independently-mounted React root, not just escMenu's own DOM subtree.
export const PALETTES: PaletteOption[] = [
  { id: 'dore', label: 'Doré', swatches: ['#050708', '#d2a84a', '#efd17a'] },
  { id: 'fer-nordique', label: 'Fer Nordique', swatches: ['#0b0d10', '#8a97a8', '#c7ccd3'] },
  { id: 'aurore', label: 'Aurore', swatches: ['#081211', '#3ecdb3', '#d9b969'] },
  { id: 'vert-de-gris', label: 'Vert-de-gris', swatches: ['#0a1210', '#7fae82', '#cdb267'] },
  { id: 'braise', label: 'Braise', swatches: ['#120a08', '#d97a3f', '#d9b969'] },
  { id: 'givre', label: 'Givre', swatches: ['#080f14', '#6fb4e0', '#c9ccd1'] },
  { id: 'sang', label: 'Sang', swatches: ['#120809', '#c0524f', '#cdb267'] },
  { id: 'malachite', label: 'Malachite', swatches: ['#080f0c', '#4fae72', '#cdb267'] },
  { id: 'rossignol', label: 'Rossignol', swatches: ['#0a0c14', '#7f8fd9', '#b9a6d9'] },
  { id: 'dwemer', label: 'Dwemer', swatches: ['#120d08', '#c98a4a', '#8a5a34'] },
];

export const PALETTE_STORAGE_KEY = 'skymp5-esc-menu-palette';
export const DEFAULT_PALETTE = 'dore';

export const getStoredPalette = (): string => {
  try {
    return window.localStorage.getItem(PALETTE_STORAGE_KEY) || DEFAULT_PALETTE;
  } catch {
    return DEFAULT_PALETTE;
  }
};

// Sets the palette on `document.documentElement` - since the `--gold-*`
// custom properties are declared on `:root` (main.scss), every panel's
// independently-mounted React root inherits the change immediately via the
// CSS cascade, with no cross-component messaging needed.
export const applyPalette = (id: string): void => {
  document.documentElement.setAttribute('data-palette', id);
  try {
    window.localStorage.setItem(PALETTE_STORAGE_KEY, id);
  } catch {
    /* ignore */
  }
};

// Called once at bootstrap (index.js) to paint the stored palette before any
// panel mounts - does not touch localStorage (nothing changed yet).
export const initPalette = (): void => {
  document.documentElement.setAttribute('data-palette', getStoredPalette());
};
